/** Strips curly braces from Dataverse GUID strings. */
export function normalizeGuid(value: string | null | undefined): string {
  if (value == null || value === '') return '';
  return String(value).replace(/[{}]/g, '');
}
